import React from "react";
import { List, ListPlus } from "lucide-react";
import "./PlayListButton.css";

/**
 * PlayListButton - Reusable Play List icon button.
 *
 * Props:
 * - isActive: boolean - Whether the game is already on the Play List.
 * - isAnonymous: boolean - Whether the user is anonymous (button disabled).
 * - onClick: () => void - Click handler.
 * - title?: string - Optional tooltip override.
 * - className?: string - Additional CSS classes.
 * - dataTestId?: string - Test ID.
 * - showLabel?: boolean - When true, renders a small text label next to the icon.
 * - showIcon?: boolean - When false, hides the icon (useful when showing a text label only).
 * - label?: string - Optional text label override.
 */
function PlayListButton({
  isActive = false,
  isAnonymous = false,
  onClick,
  title,
  className = "",
  dataTestId,
  showLabel = false,
  showIcon = true,
  label,
  style = {},
}) {
  const isDisabled = isAnonymous;

  const resolvedTitle = title || (isAnonymous
    ? "Login to use Play List"
    : isActive
      ? "Remove from Play List"
      : "Add to Play List");

  const handleClick = (e) => {
    e.stopPropagation();
    if (!isDisabled && onClick) {
      onClick(e);
    }
  };

  const dynamicStyle = {
    cursor: isDisabled ? "not-allowed" : "pointer",
    opacity: isDisabled ? 0.5 : 1,
    ...style,
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      title={resolvedTitle}
      aria-label={resolvedTitle}
      className={`playlist-button ${isActive ? 'playlist-button--active' : ''} ${className}`}
      data-testid={dataTestId}
      style={dynamicStyle}
    >
      {showIcon && (
        isActive ? (
          <ListPlus size={18} />
        ) : (
          <List size={18} />
        )
      )}
      {showLabel && (
        <span className="playlist-button__label">
          {label || (isAnonymous ? "Play List" : isActive ? "Added" : "Add to Play List")}
        </span>
      )}
    </button>
  );
}

export default PlayListButton;
